import React, { PureComponent } from 'react'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
import appUrl, { openPost } from '@libs/appUrl'
import { withTranslation } from '@hocs'

class LoginAlert extends PureComponent {
  static defaultProps = {
    isOpen: false,
    onClose: () => false,
    target: '_blank',
    t: () => false,
  }

  render() {
    const { isOpen, onClose, t } = this.props
    return (
      isOpen && (
        <Dialog open={true} TransitionComponent={Transition} keepMounted onClose={onClose}>
          <DialogTitle>{t('請先登入')}</DialogTitle>
          <DialogContent>
            <DialogContentText>{t('此操作需要登入才能使用喔！')}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary">
              {t('取消')}
            </Button>
            <Button onClick={this._onGoLoginPage} color="primary">
              {t('確定')}
            </Button>
          </DialogActions>
        </Dialog>
      )
    )
  }
  _onGoLoginPage = (e) => {
    e.stopPropagation()
    const { target, onClose } = this.props
    openPost(`${appUrl.appUrl}/login`, target)
    onClose()
  }
}

export default withTranslation(['common'])(LoginAlert)
